import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";

import getPlural from "ati-utils/pluralize";

import LicenseModel from "../../../../../store/models/Licenses/License";

import strings from "../../../../../locales/strings";

import styles from "../ProfileDropdown.scss";

const cx = classnames.bind(styles);

const profileLicenses = {
  ADDITIONAL_CONTACTS: 561,
  REAL_TRUCKER: 559,
};

const License = ({ license, locale }) => (
  <span key={license.serviceName} className={cx("license-name")}>
    {license.serviceId === profileLicenses.ADDITIONAL_CONTACTS ? (
      // вывод счетчика дополнительных контактов
      license.serviceAmount > 0 && (
        <>
          +{license.serviceAmount}&nbsp;
          {getPlural(strings.contactsByLicense, license.serviceAmount, locale)}
        </>
      )
    ) : (
      // поддержка всех остальных лицензий
      <>
        {license.serviceName}
        {license.serviceId === profileLicenses.REAL_TRUCKER &&
          license.serviceAmount > 0 && (
            <span>
              &nbsp;({license.serviceAmount}&nbsp;{strings.veh})
            </span>
          )}
      </>
    )}
  </span>
);

License.propTypes = {
  license: PropTypes.instanceOf(LicenseModel),
  locale: PropTypes.string,
};

export default License;
